import Cookies from 'universal-cookie'

const gqlServer = () => {
  return 'https://interact.bluprevent.de/node/graphql'
}
const cookies = new Cookies()

function getCookie(cname) {
  var name = cname + '='
  var decodedCookie = decodeURIComponent(document.cookie)
  var ca = decodedCookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) == ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

const checkAvailability = () =>
  fetch('https://interact.bluprevent.de/node/public/')
const checkServerAvailability = () =>
  fetch('https://interact.bluprevent.de/checkAvailability.php')

const gqlFetch = <T>(query, variables = {}, useToken = true): Promise<T> =>
  new Promise((resolve, reject) => {
    const body = JSON.stringify({
      query: query.replace(/\s/gm, ''),
      variables,
    })
    const headers = {
      'Content-Type': 'application/json',
    }
    if (useToken) {
      headers['blu-authorization-token'] = cookies.get(
        'blu-authorization-token'
      )
    }

    fetch(gqlServer(), {
      method: 'POST',
      headers,
      body,
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.errors) return Promise.reject(response.errors[0])
        return response.data as T
      })
      .then(resolve)
      .catch(reject)
  })

const getCurrentUser = () =>
  new Promise<{ id: string; name: string; displayname: string; email: string }>(
    (resolve, reject) => {
      gqlFetch<{
        currentUser: {
          id: string
          name: string
          displayname: string
          email: string
        }
      }>(`
		query {
			currentUser {
				id,
				name,
				displayname,
				email
			}
		}
	`)
        .then((data) => data.currentUser)
        .then((user) => {
          if (user.id === null) return Promise.reject('Not logged in')
          return Promise.resolve(user)
        })
        .then(resolve)
        .catch(reject)
    }
  )

const login = (username, password) =>
  new Promise((resolve, reject) => {
    getCurrentUser()
      .then(resolve)
      .catch(() =>
        gqlFetch<{ login: string }>(
          `
                mutation ($username:String!,$password:String!) {
                    login(username:$username, password:$password)
                }
            `,
          { username, password },
          false
        )
          .then(({ login: token }) => {
            cookies.set('blu-authorization-token', token, { path: '/' })
            cookies.remove('blu-trial', { path: '/' })
          })
          .then(getCurrentUser)
          .then(resolve)
      )
      .catch((e) => reject(e.message))
  })

const forgotPassword = (email) =>
  new Promise<Response>((resolve, reject) => {
    const params = new URLSearchParams()
    params.append('action', 'blu_forgot_password')
    params.append('email', email)

    return getCurrentUser()
      .then(reject)
      .catch(() =>
        // @ts-ignore
        fetch(ajaxurl[0], {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: params,
        }).then(resolve)
      )
      .catch((e) => reject(e.message))
  })

const startTrial = () =>
  new Promise((resolve, reject) => {
    getCurrentUser()
      .catch(() =>
        gqlFetch<{ startTrial: string }>(
          `
                mutation {
                    startTrial
                }
            `,
          {},
          false
        )
          .then(({ startTrial: token }) => {
            cookies.set('blu-authorization-token', token, { path: '/' })
            cookies.set('blu-trial', 1, { path: '/' })
          })
          .then(getCurrentUser)
      )
      .then(resolve)
      .catch((e) => reject(e.message))
  })

const redirect = () => {
  window.location.href = 'https://interact.bluprevent.de/app'
}

export {
  getCurrentUser,
  checkAvailability,
  checkServerAvailability,
  login,
  forgotPassword,
  startTrial,
  redirect,
}
